module.exports = __webpack_public_path__ + "img/banner1-icon.12abdef4.png";